import { render } from "./NotificationsButton.vue?vue&type=template&id=97cb307a&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import "./NotificationsButton.vue?vue&type=style&index=0&id=97cb307a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cb307a"]])

export default __exports__